var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(!_vm.object)?_c('span',[_vm._v(_vm._s(_vm.tribeId))]):_c('a',{attrs:{"href":'/tribe/' + _vm.object.id}},[_vm._v(_vm._s(_vm.object.name || _vm.tribeId))])])}
var staticRenderFns = []

export { render, staticRenderFns }